import { h } from 'preact'
import * as _ from '../vendor/lodash'

export default function studyRewardNotificationBucketView ({ bucket, bucketChanged, bucketChangeDirection }) {
  return bucketChanged && h('div', {
    class: `reward-notification ${bucketChangeDirection === 'up' ? 'good' : 'bad'}`
  }, _.capitalize(bucket))
}
